module.exports = __webpack_public_path__ + "fbe10ef0330ab9d2233f57db7f7c7e8f.svg";